"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COMPARISON_MEASURE_COLUMN_NAME = 'comparisonMeasure';
exports.COMPARISON_TIMESTAMP_COLUMN_NAME = 'comparisonTimestamp';
//# sourceMappingURL=defaults.js.map